"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = {
    dataDimension: true
};
module.exports = exports["default"];
//# sourceMappingURL=categoryOptionGroupSet.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/categoryOptionGroupSet.js
// module id = 415
// module chunks = 0